export default "__VITE_ASSET__14947a79__"